import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import styles from './styles';
// import data from './fiveDayForecastData.json';
import icons from '../../assets/images';
import sampleFiveDayForecast from './FiveDayForecastData';

class FiveDayForecast extends React.PureComponent {
  render() {
    const {
      classes: { container, dayPanel, lastPanel },
    } = this.props;
    const FiveDayWeatherForecast = unescape(sampleFiveDayForecast);
    const FiveDayWeatherForecastData = JSON.parse(FiveDayWeatherForecast);
    const { WeatherForecasts: wc } = FiveDayWeatherForecastData;
    return (
      <React.Fragment>
        <div className={container}>
          <div className={dayPanel}>{this.renderDayPanel(wc[0])}</div>
          <div className={dayPanel}>{this.renderDayPanel(wc[1])}</div>
          <div className={dayPanel}>{this.renderDayPanel(wc[2])}</div>
          <div className={dayPanel}>{this.renderDayPanel(wc[3])}</div>
          <div className={lastPanel}>{this.renderDayPanel(wc[4])}</div>
        </div>
      </React.Fragment>
    );
  }

  /**
   * @name renderCenterPanel
   * @description render the DOM for the Center Panel
   */
  renderDayPanel = wc => {
    const {
      classes: {
        panelContents,
        panelSection,
        panelTitleText,
        tempHigh,
        tempLow,
        weatherIcon,
        weatherInfoText,
        precipText,
      },
    } = this.props;
    const weatherImage = `weather${wc.WeatherIcon}`;
    return (
      <React.Fragment>
        <div className={panelSection}>
          <div className={panelContents}>
            <div className={panelTitleText}>{wc.Date.substring(0, 3)}</div>
          </div>
          <div className={panelContents}>
            <div className={weatherIcon}>
            <img alt="weather" src={icons[weatherImage]} />
            </div>
          </div>
          <div className={panelContents}>
            <div>
              <div className={tempHigh}>{wc.Temperature.High.Value}&#176;</div>
              <div className={tempLow}>{wc.Temperature.Low.Value}&#176;</div>
            </div>
            {/* <div className={panelTitleText}>{wc.temperature.low.value}&#176;</div> */}
          </div>

          <div className={panelContents}>
            <div>
              <div className={precipText}>{`${wc.PreciProbability}% precip.`}</div>
              <div className={weatherInfoText}>{wc.WeatherText}</div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
}

FiveDayForecast.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(FiveDayForecast));
